import React, { useContext } from "react";
import { Button, Tooltip, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import AccountTabs from "./AccountTabs";
import textStyles from "../../styles/Custom/Typography.module.css";
import styles from "../../styles/Custom/Dashboard/Users.module.css";
import { UserContext } from "../../context/UserContext";
import { getCookie } from "../../helpers/localStorage";
import { FacilityID, Role } from "../../constants/defaultKeys";
import { getRoleDashboardPath } from "../../helpers/auth/helper";
import useIsMobile from "../../hooks/useIsMobile";

const AccountHeader = ({ showTitle = true }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const facilityId =
    Number(getCookie(FacilityID)) || userDetails?.currFacility;
  const roleObj = userDetails?.activeOrg?.roles?.find(
    (r) => r.role === defaultRole && r.facility_id === Number(facilityId)
  );

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(getRoleDashboardPath(defaultRole, roleObj), { replace: true });
    }
  };

  if (isMobile) {
    return <Typography className={textStyles.h6}>Account</Typography>;
  }

  return (
    <div
      className={`${
        showTitle ? styles.accountHeader : styles.accountHeaderDoctor
      } flex-start`}
    >
      <Tooltip title="Back">
        <Button
          type="text"
          shape="circle"
          icon={<LeftOutlined />}
          onClick={goBack}
          className={styles.accountBackBtn}
        />
      </Tooltip>
      {showTitle && (
        <Typography className={textStyles.h6}>Account</Typography>
      )}
      <AccountTabs />
    </div>
  );
};

export default AccountHeader;
